import { render, staticRenderFns } from "./MoveInternational.vue?vue&type=template&id=ffb52caa&scoped=true&"
import script from "./MoveInternational.vue?vue&type=script&lang=js&"
export * from "./MoveInternational.vue?vue&type=script&lang=js&"
import style0 from "./MoveInternational.vue?vue&type=style&index=0&id=ffb52caa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb52caa",
  null
  
)

export default component.exports